import React, { SetStateAction } from 'react';
import { useTranslation } from 'react-i18next';
import { Modal, Checkbox, FormControlLabel } from '@mui/material';
import { Box, Flex } from '@/layout';
import { ModalForm, ModalTitle } from '../style';
import { Button } from '@/components/UI/Button';
import { Text } from '@/components/UI/Typography/Text';
import { theme } from '@/theme/Theme';
import { errorHandler, successHandler } from '@/utils/toastHandler';
import { deleteUserMeetingRecordings } from '@/api/event.api';

interface ModalProps {
    showModal: boolean;
    setShowModal: React.Dispatch<SetStateAction<boolean>>;
    setIsLoading: React.Dispatch<SetStateAction<boolean>>;
    recordID: string;
    initData: () => Promise<void>;
}

const DeleteModal = ({ showModal, setShowModal, recordID, setIsLoading, initData }: ModalProps) => {
    // @ts-ignore
    const { t } = useTranslation();

    const deleteRecord = async () => {
        if (!recordID) return;
        setIsLoading(true);
        try {
            setShowModal(false);
            const data = (await deleteUserMeetingRecordings(recordID)).data;
            if (data.success) {
                successHandler(t('success.delete'));
                await initData();
            }
        } catch (error) {
            setShowModal(false);
            errorHandler(t('error.videoDeleteFailed'));
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Modal
            open={showModal}
            onClose={() => setShowModal(false)}
            aria-labelledby="simple-modal-title"
            aria-describedby="simple-modal-description"
            disableEnforceFocus
        >
            <ModalForm>
                <ModalTitle>{t('pages.event.meetingVideo.modal.delete.title')}</ModalTitle>
                <Box marginTop={15}>
                    <Text color={theme.colors.gray500}>
                        {t('pages.event.meetingVideo.modal.delete.content')}
                    </Text>
                </Box>
                <Box
                    style={{ marginTop: '50px', display: 'flex', gap: '30px', alignItems: 'center', justifyContent: 'center' }}
                >
                    <Button size={'lg'} variant={'danger'} onClick={() => deleteRecord()}>
                        {t('buttons.delete')}
                    </Button>
                    <Button
                        size={'lg'}
                        variant={'primary-invert'}
                        color="primary"
                        onClick={() => setShowModal(false)}
                        style={{ textDecoration: 'underline' }}
                    >
                        {t('buttons.cancel')}
                    </Button>
                </Box>
            </ModalForm>
        </Modal>
    );
};

export default DeleteModal;